import styled from "styled-components"
import theme from "../../theme"

const ModalCardHeader = styled<any, "header">("header")`
  border-bottom: 1px solid ${theme.colors.text};
  align-items: center;
  background: ${theme.colors.modalBody};
  color: ${theme.colors.modalText};
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 20px;
  position: relative;
  z-index: 2;
  @media screen and (max-width: 481px) {
    flex-direction: column;
    padding-bottom: 2px;
    padding-top: 30px;
  }
`

export default ModalCardHeader
